import { gql } from '@apollo/client';

export const ParagraphInfolinoRatingFragment = gql`
    fragment ParagraphInfolinoRatingFragment on ParagraphInfolinoRating {
        id
    }
`;
